import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Segmento } from '../page/segmento/segmento';

@Injectable({ providedIn: 'root' })
export class SegmentoService {

  private apiURL = environment.apiBaseUrl + 'segmento';

  constructor(private http: HttpClient) { }

  listar(): Observable<Segmento[]> {
    return this.http.get<Segmento[]>(this.apiURL);
  }

  listarAtivos(): Observable<Segmento[]> {
    return this.http.get<Segmento[]>(`${this.apiURL}/ativos`);
  }

  buscarPorId(id: number): Observable<Segmento> {
    return this.http.get<Segmento>(`${this.apiURL}/${id}`);
  }

  salvar(segmento: Segmento): Observable<Segmento> {
    if (segmento.id) {
      return this.http.put<Segmento>(`${this.apiURL}/${segmento.id}`, segmento);
    }
    return this.http.post<Segmento>(this.apiURL, segmento);
  }

  inativar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }
}
